<template>
  <div class="page-content znjcTable" :style="defaultHeight">
    <div class="startTitle">我的订单</div>
    <!--<el-row class="lineH">
      <el-col :span="12" class="znjc_tit" >
        <img src="../../assets/images/back/znjc_xy.png" alt="">
        <span>血压</span>
      </el-col>
      <el-col :span="12" class="textR">
        <el-button type="info" class="seeqsfxBtn" @click="toqsfxPage()">查看趋势分析</el-button>
      </el-col>
    </el-row>-->
<!--     <div class="inlineBtn">
      <el-button :class="btn_index==0?'act':''" @click="orderType_click(0)">全部订单</el-button>
      <el-button :class="btn_index==1?'act':''" @click="orderType_click(1)">待支付</el-button>
      <el-button :class="btn_index==2?'act':''" @click="orderType_click(2)">待发货</el-button>
      <el-button :class="btn_index==3?'act':''" @click="orderType_click(3)">已收货</el-button>
      <el-button :class="btn_index==4?'act':''" @click="orderType_click(4)">已完成</el-button>
      <el-button :class="btn_index==5?'act':''" @click="orderType_click(5)">订单失效</el-button>
    </div> -->
    <el-row class="filter">
      <el-col :span="24">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="订单号">
            <el-input v-model="formInline.orderNum" placeholder="请输入订单号" clearable style="width: 250px;" />
          </el-form-item>
          <el-form-item label="订单状态">
            <el-select v-model="formInline.btn_orderType" placeholder="请选择" clearable style="width: 190px;">
              <el-option label="全部订单" value="0"></el-option>
              <el-option label="待支付" value="1"></el-option>
              <el-option label="待发货" value="2"></el-option>
              <el-option label="已收货" value="3"></el-option>
              <el-option label="已完成" value="4"></el-option>
              <el-option label="订单失效" value="5"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订单类型">
            <el-select v-model="formInline.sel_orderType" placeholder="请选择" clearable style="width: 190px;">
                            <el-option :label="val.activityName" :value="val.id" :key="val.id" v-for="val in vipCommodityList"></el-option>
             <!--  <el-option label="会员订单" value="0"></el-option>
              <el-option label="商品订单" value="1"></el-option>
              <el-option label="一元体验订单" value="2"></el-option> -->
            </el-select>
          </el-form-item>
          <el-form-item style="float: right">
            <el-button type="success" @click="searchClick()" class="dmh-btn sec-btn">搜索</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table v-loading="loading" :data="tableData" border style="width: 100%">
          <el-table-column prop="orderNum" label="订单编号">
          </el-table-column>
          <el-table-column prop="orderType" label="订单类型" width="180">
          </el-table-column>
          <el-table-column prop="state" :formatter="set_state" label="订单状态">
          </el-table-column>
          <el-table-column prop="orderPrice" label="订单金额">
          </el-table-column>
          <el-table-column prop="commodityGifts" :formatter="set_commodityGifts" label="订单名称">
          </el-table-column>
          <el-table-column prop="payTime" label="支付时间">
          </el-table-column>
          <el-table-column prop="addTime" label="创建时间">
          </el-table-column>
          <!--   <el-table-column fixed="right" label="操作" width="120">
            <template slot-scope="scope">
              <el-button @click.native.prevent="itemSeedeatilRow(scope.row)" type="text" size="small">
                订单详情
              </el-button>
            </template>
          </el-table-column> -->
        </el-table>
      </el-col>
      <el-col :span="24" class="paginationBox">
        <pagination style="float:right;background: none;" class="paginationBox dmh-page" v-show="total>0" :total="total" :page.sync="currentPage" :limit.sync="pageSize" @pagination="getList" layout="prev, pager, next" />
      </el-col>
    </el-row>
    <el-row>
      <!--  <el-col :span="4" class="paginationBox">
        <el-button type="success" @click="searchClick()" style="float: left;margin-top: 30px;">马上体验</el-button>
      </el-col> -->
      
    </el-row>
  </div>
</template>
<script>
import '@/assets/css/backcommon.css'
import { request } from '@/network/request'
export default {
  data() {
    return {
      vipCommodityList:[],
      btn_index: 0,
      loading: true,
      defaultHeight: {
        height: ""
      },
      buttonIndex: -1,
      firstPage: 1,
      prevPage: "",
      nextPage: "",
      total: 0,
      lastPage: "", //1000/10
      currentPage: 1,
      pageSize: 10,
      tableData: [],
      formInline: {
        btn_orderType: '0', //全部订单  未付款  已付款  已完成
        sel_orderType: '', //订单类型
        orderNum: "", //订单号
      },
      isDateShow: true,
      params: ""
    }
  },
  components: {},
  mounted() {
    //页面创建时执行一次getHeight进行赋值，顺道绑定resize事件
    window.addEventListener("resize", this.getHeight);
    this.getHeight();
    this.getList()
    this.getVipCommodityList().then(res => {
        if (res.data.code == 200) {
      
      this.vipCommodityList = res.data.data;
      // console.log(111)
      //     console.log(this.vipCommodityList)
        }
      })
  },
  methods: {
     getVipCommodityList() {
      return request({
        url: '/api/commodity/aiCommodity/getVipCommodityList',
        method: 'get',
      })
    },
    //定义方法，获取高度减去头尾
    getHeight() {
      this.defaultHeight.height = window.innerHeight - 105 + "px";
    },
    set_state(row, column) {
      // 1 待支付 2待发货 3已收货 4已完成 5订单失效
      switch (row.state) {
        case "1":
          return "待支付";
        case "2":
          return "待发货";
        case "3":
          return "已收货";
        case "4":
          return "已完成";
        case "5":
          return "订单失效";

      }

    },
    itemSeedeatilRow(row) {

    },
    set_commodityGifts(row) {
      console.log(row.commodityGifts);
      var commodityGifts = row.commodityGifts;
      var str = ""
      for (var i = 0; i < commodityGifts.length; i++) {
        str += commodityGifts[i].name + (i < commodityGifts.length - 1 ? "，" : "")
      }
      return str;
    },
    oderList(data) {
      return request({
        url: '/api/commodity/aiCommodity/oderList',
        method: 'get',
        params: data
      })
    },
    paramsFn() {
      this.params = {
        "orderType":'',
        "type": this.formInline.btn_orderType,
        "commodityId": this.formInline.sel_orderType,
        "orderNumber": this.formInline.orderNum,
        "pageSize": this.pageSize, //每页数量
        "pageNumber": this.currentPage
      };
    },
    //点击搜索
    searchClick() {
      this.resetPage();
      this.getList();
    },
    //重置页数
    resetPage() {
      this.currentPage = 1;
    },
    //请求数据
    getList() {

      var ths = this;
      ths.loading = true;
      ths.paramsFn();
      ths.oderList(ths.params).then(res => {
        if (res.data.code == 200) {
          if (res.data.data.orderList == null) {
            ths.total = 0;
            ths.tableData = [];
            ths.loading = false;
            return
          }
          ths.tableData = res.data.data.orderList;
          ths.total = parseFloat(res.data.data.total);
          ths.lastPage = parseFloat(res.data.data.total) / 10;
          ths.loading = false;
        } else if (res.data.code == 500) {
          ths.total = 0;
          ths.tableData = [];
          ths.loading = false;
          /* ths.message("您还没有下过订单，快去购物吧！");*/
        }
      })
    },
    orderType_click(type) {
      this.formInline.btn_orderType = this.btn_index = type;
      this.formInline.sel_orderType = "";
      this.formInline.orderNum = "";
      this.resetPage();
      this.getList();
    }
  },
}

</script>
<style scoped>
/*.dmh-page{
  display: flex;
  align-content: center;
}*/
.paginationBox .totaltext {
  top: 0;
}

.znjcTable .inlineBtn {
  padding-top: 20px;
  border-bottom: 1px solid #eee;
  padding-bottom: 20px;
}

.znjcTable .inlineBtn .el-button {
  line-height: 8px;
}

.znjcTable .lineH {
  /*line-height: 60px;*/
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ededed;
}

.znjcTable .filter {
  padding-left: 10px;
  padding-top: 22px;
  padding-bottom: 1px;
}

.znjcTable .textR {
  text-align: right;
}

.znjc_tit img {
  position: relative;
  /*top: 10px;*/
  left: 10px;
  width: 40px;
  height: 40px;
  display: inline-block;
}

.znjc_tit span {
  margin-left: 15px;
  display: inline-block;
  font-size: 28px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
}

.seeqsfxBtn {
  margin-right: 20px;
  background-color: #59677f;
  border-radius: 3px;
}

.paginationBox {
  padding-right: 20px;
}

.paginationBox .el-pagination {
  display: inline-block !important;
}

/*.paginationBox .el-button {
  padding: 7px 8px;
  position: relative;
  top: 10px;
}*/
.act {
  color: #409eff;
  border-color: #c6e2ff;
  background-color: #ecf5ff;
}

.sec-btn {
  background: #14c86c;
  border-color: #14c86c;
}

.sec-btn:hover {
  background: #14c86c;
  border-color: #14c86c;
  opacity: 0.9;
}

</style>



// WEBPACK FOOTER //
// src/views/personCenter/myOrder.vue